import React, { useState, useRef } from "react";


import BCButtonWithDropdown from "../topBar/components/BCButtonWithDropdown";
import FlameButtonWithDropdown from "../topBar/components/FlameButtonWithDropdown";
import CoinButtonWithDropdown from "../topBar/components/CoinButtonWithDropdown";
import BoltButtonWithDropdown from "../topBar/components/BoltButtonWithDropdown";
import PremiumButton from "../../../premium/PremiumButton";
import "./TopBar.css";

const TopBar = () => {

  return (
    <div className="rightmenu-card-stats stats-card">
      <div className="stats-orientation-top-lessons">
        <BCButtonWithDropdown />
        <FlameButtonWithDropdown />
        <CoinButtonWithDropdown />
        <BoltButtonWithDropdown />
        <PremiumButton />
      </div>
    </div>
  );
};

export default TopBar;
